module.exports = __webpack_public_path__ + "img/swift.96d2675b.png";